import { render } from "./TechItsOurStackComp.vue?vue&type=template&id=23fef0e2&scoped=true"
import script from "./TechItsOurStackComp.vue?vue&type=script&lang=js"
export * from "./TechItsOurStackComp.vue?vue&type=script&lang=js"

import "./TechItsOurStackComp.vue?vue&type=style&index=0&id=23fef0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fef0e2"]])

export default __exports__